<template>
  <div class="header">
    <div class="head-left">
      <img v-if="username!='daide'" src="../assets/logo.png" alt="" />

      <div>
        <span style="padding-left: 5px;" class="titleName">智慧声纹实时监测系统</span>
      </div>

      <div class="menu">
        <span tabindex="0" :class="flag === 1 ? 'focus-span' : ''" @click="flag = 1, $router.push('/home/site')">首页</span>
        <span tabindex="1" :class="flag === 2 ? 'focus-span' : ''" @click="flag = 2, $router.push('/equip')">设备管理</span>
        <span v-if="$store.state.role == 1" tabindex="3" :class="flag === 4 ? 'focus-span' : ''"
          @click="flag = 4, $router.push('/model')">模型管理</span>
        <span tabindex="2" :class="flag === 3 ? 'focus-span' : ''"
          @click="flag = 3, $router.push('/system/passwdSet')">系统设置</span>
        <!-- <span tabindex="4" :class="flag === 5 ? 'focus-span' : ''"
          @click="flag = 5, $router.push('/siteManagement')">站点管理</span> -->
      </div>
    </div>

    <div class="head-right">
      <img style="cursor: pointer;" @click="light" v-if="theme == 1" src="../assets/theme_dark.png" alt="" />
      <img style="cursor: pointer;" @click="dark" v-if="theme == 2" src="../assets/theme_light.png" alt="" />
      <!-- <img src="../assets/head1.png" alt="" /> -->
      <img src="../assets/head2.png" alt="" />
      <div class="dateTime">
        <div class="datetext">
          <span class="text">{{ date }}</span>
          <span class="text week">{{ day_of_week }}</span>
        </div>

        <span class="timetext">{{ time }}</span>
      </div>
      <div class="line"></div>
      <img src="../assets/head3.png" alt="" />
      <div class="user-info">
        <span>{{ username }}</span>
      </div>
      <!-- <el-dropdown trigger="click" style="padding-left: 20px; height: 36px; width: 36px; line-height: 40px">
          <img class="headphoto" style="width: 100%;height: 100%;cursor: pointer;"   src="../assets/quit.png" alt="" />
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item  @click.native="toSetting(1)">用户管理</el-dropdown-item>
            <el-dropdown-item @click.native="toSetting(2)">操作日志</el-dropdown-item>
            <el-dropdown-item  @click.native="toSetting(4)">修改密码</el-dropdown-item>
            <el-dropdown-item  @click.native="toSetting(5)">设备管理</el-dropdown-item>
            <el-dropdown-item  @click.native="toSetting(6)">数据统计</el-dropdown-item>
            <el-dropdown-item @click.native="quit" >退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      <img style="cursor: pointer;" @click="quit" src="../assets/quit.png" alt="" />
    </div>
  </div>
</template>
  
<script>
import screenfull from "screenfull";
import commonUtils from "../utils/common";

export default {
  components: {},
  data() {
    return {
      //全屏
      isScreenfull: false,
      //时间
      date: "",
      time: "",
      day_of_week: "",
      flag: 1,
      theme: 1, //1:dark 2:light
      role: '',
      username: ''
    };
  },
  mounted() {
    this.initScreenfull();
    this.initTime();
    const roleNum = Number(window.sessionStorage.getItem('role'))
    this.role = this.getroleName(roleNum)
    this.username = window.sessionStorage.getItem('username')
    this.dark()

  },
  methods: {
    dark() {
      this.theme = 1;
      document.documentElement.style.setProperty('--primary-color', '#081118');
      document.documentElement.style.setProperty('--primary-color2', 'rgb(17, 32, 38)');
      document.documentElement.style.setProperty('--titleName-color', '#FFFFFF');
      document.documentElement.style.setProperty('--Gradient-color1', 'rgba(17, 33, 38, 0.3)');
      document.documentElement.style.setProperty('--Gradient-color2', 'rgba(95, 227, 229, 0.3)');
      document.documentElement.style.setProperty('--cardbg-color', '#091823');
      document.documentElement.style.setProperty('--borderImage', 'rgba(0, 0, 0, 1)');
      document.documentElement.style.setProperty('--audio-text-bg', '#151618');
      document.documentElement.style.setProperty('--audio-bg', '#020202');
      document.documentElement.style.setProperty('--table-row-highlight', 'hsla(0, 0%, 100%, .05)');
      document.documentElement.style.setProperty('--white-and-green', '#ffffff');
      document.documentElement.style.setProperty('--input-bg', 'rgba(36, 68, 71, 0.31)');
      document.documentElement.style.setProperty('--input-border-color', 'rgba(192, 233, 255, 0.31)');
      document.documentElement.style.setProperty('--statusbg-color', '#24444756');
      document.documentElement.style.setProperty('--hoverbg-color', 'rgba(36, 68, 71, 0.155)');
      document.documentElement.style.setProperty('--hoverbd-color', '#244447');
      document.documentElement.style.setProperty('--hoversd-color', 'rgba(0, 0, 0, 0.41)');
      document.documentElement.style.setProperty('--hoverTspan-color', '#deebff');
      document.documentElement.style.setProperty('--datePicker-color', '#2e393e');
      document.documentElement.style.setProperty('--tableLine-color', 'rgba(17, 32, 38, 1)');
      document.documentElement.style.setProperty('--tooltipcardbg-color', 'rgba(36, 68, 71, .7)');
    },
    light() {
      this.theme = 2;
      document.documentElement.style.setProperty('--primary-color', '#FAFAFA');
      document.documentElement.style.setProperty('--primary-color2', '#FFFFFF');
      document.documentElement.style.setProperty('--titleName-color', '#244447');
      document.documentElement.style.setProperty('--Gradient-color1', '#fff');
      document.documentElement.style.setProperty('--Gradient-color2', '#F3FFFF');
      document.documentElement.style.setProperty('--cardbg-color', '#fff');
      document.documentElement.style.setProperty('--borderImage', 'rgba(255, 255, 255, 1)');
      document.documentElement.style.setProperty('--audio-text-bg', 'rgba(0,0,0,0.1)');
      document.documentElement.style.setProperty('--audio-bg', '#F2F2F2');
      document.documentElement.style.setProperty('--table-row-highlight', '#E8FAF6');
      document.documentElement.style.setProperty('--white-and-green', '#44D7B6');
      document.documentElement.style.setProperty('--input-bg', '#ffffff');
      document.documentElement.style.setProperty('--input-border-color', '#44D7B6');
      document.documentElement.style.setProperty('--statusbg-color', '#d1d4d48d');
      document.documentElement.style.setProperty('--hoverbg-color', 'rgba(241,254,255,0.8)');
      document.documentElement.style.setProperty('--hoverbd-color', '#A8EBF2');
      document.documentElement.style.setProperty('--hoversd-color', 'rgba(218,218,218,0.41)');
      document.documentElement.style.setProperty('--hoverTspan-color', 'rgba(8, 17, 24, 1)');
      document.documentElement.style.setProperty('--datePicker-color', '#F2F6FC');
      document.documentElement.style.setProperty('--tableLine-color', 'rgba(245, 247, 250, 1)');
      document.documentElement.style.setProperty('--tooltipcardbg-color', '#fff');


    },
    toSetting(flag) {
      this.$router.push("/setting");
      this.$store.state.setflag = flag;
    },
    getroleName(number) {
      switch (number) {
        case 1:
          return '管理员';

        case 2:
          return '普通用户';

      }
    },
    //时间相关方法
    initTime() {
      this.date = commonUtils.timeFormat(new Date()).slice(0, 11);
      this.time = commonUtils.timeFormat(new Date()).slice(11);
      this.day_of_week = commonUtils.getDayOfWeek(new Date());
      setInterval(() => {
        this.time = commonUtils.timeFormat(new Date()).slice(11);
      }, 1000);
    },
    //全屏相关方法
    initScreenfull() {
      if (screenfull.isEnabled) {
        screenfull.on("change", this.change); // 开启监听
      }
    },
    change() {
      this.isScreenfull = screenfull.isFullscreen; // 更新全屏状态
    },
    getScreenfull() {
      if (!screenfull.isEnabled) {
        this.$message({
          message: "你的浏览器暂不支持全屏",
          type: "error",
        });
        return false;
      }
      screenfull.toggle();
    },
    //退出按钮
    quit() {
      this.$confirm("是否确定退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(res => {
        this.$store.commit("$_removeStorage"); // 清除登录信息
        this.$router.push("/");
      })

      // this.$store.commit("$_removeStorage"); // 清除登录信息
      // this.$router.push("/");
      // window.location.reload();
    },
    home() {
      this.$router.push("/layout");
      this.$store.state.isShowMap = true;
      // window.location.reload();
    },
  },
  computed: {},
};
</script>
  
<style lang="less" scoped>
.header {
  width: 100%;
  position: relative;
  height: 4.375rem;
  background-color: transparent;
  display: flex;
  justify-content: space-between;
  min-width: 1440px;
  z-index: 5;
  background: linear-gradient(270deg,
      var(--Gradient-color1) 0%,
      var(--Gradient-color2) 100%);

  img {
    // position: absolute;
    // bottom: 0px;
  }
}

.header::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  border-top: 2px solid;
  border-image: linear-gradient(270deg,
      var(--borderImage),
      rgba(68, 215, 182, 1)) 1 1;
  border-image-slice: 1;
}


.weatherName {
  padding: 0.3125rem 0.5rem;
  width: 5.5rem;
  height: 1.875rem;
  font-size: 1.375rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #d5f2ff;
  line-height: 1.875rem;
  opacity: 1;
}

.s-weatherName {
  width: 2rem;
  height: 1.25rem;
  font-size: 0.875rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #d5f2ff;
  line-height: 1.25rem;
}

.head-left {
  width: 79.25rem;
  height: 4.375rem;
  line-height: 4.375rem;
  display: flex;
  align-items: center;
  z-index: 20;

  img {
    height: 2.0625rem;
    width: 2rem;
    padding-left: 1.625rem;
    padding-right: 1.25rem;
  }
}

.head-middle {
  height: 4.375rem;
  line-height: 4.375rem;
  display: flex;
  align-items: center;
  z-index: 20;
}

.head-right {
  // width: 29.25rem;
  height: 4.375rem;
  line-height: 4.375rem;
  display: flex;
  align-items: center;
  z-index: 20;
  padding-right: 1.25rem;

  img {
    height: 2.75rem;
    width: 2.75rem;
  }

  // img:nth-of-type(2) {
  //   padding-left: 1.25rem;
  // }

  img:nth-of-type(4) {
    margin-left: 1.25rem;
  }

  .line {
    width: 0.0625rem;
    height: 1.375rem;
    background-color: #44d7b6;
    margin: 1.25rem;
  }
}

.titleName {
  font-size: 1.25rem;
  font-family: douyu;
  color: var(--titleName-color);
  font-weight: 400;
}

.dateTime {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-width: 5rem;
  text-align: center;

  .datetext {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding-left: 1.25rem;
  }

  .text {
    font-size: 0.625rem;
    font-family: SourceHanSansCN-ExtraLight, SourceHanSansCN;
    font-weight: 200;
    color: #44d7b6;
    line-height: 0.75rem;
  }

  .timetext {
    padding-left: 1.25rem;
    width: 6.25rem;
    font-size: 1.625rem;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #44d7b6;
    line-height: 2.4375rem;
  }
}

.user-info {
  padding-bottom: 4px;

  span {

    width: 2.25rem;
    height: 0.75rem;
    font-size: 0.75rem;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #44d7b6;


  }
}

.menu {
  display: flex;
  flex-direction: row;
  width: 23rem;
  height: 100%;
  margin-left: 1.25rem;

  span {
    text-align: center;
    height: 4.375rem;
    font-size: 1rem;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    color: var(--titleName-color);
    line-height: 4.375rem;
    cursor: pointer;
    width: 5.375rem;
  }

  span:hover {
    color: #44D7B6;
    background: rgba(39, 99, 100, 0.108);
  }

  span:active {
    color: #44D7B6;
    background: rgba(39, 99, 100, 0.108);
  }

  span:focus {
    color: #44D7B6;
    background: rgba(39, 99, 100, 0.108);
  }
}

.focus-span {
  color: #44D7B6 !important;
}

@media screen and (max-width: 1440px) {
  .header {
    width: 100%;
    position: relative;
    height: 70px;
    background-color: transparent;
    display: flex;
    justify-content: space-between;
    min-width: 1440px;
    z-index: 5;
    background: linear-gradient(270deg,
        var(--Gradient-color1) 0%,
        var(--Gradient-color2) 100%);

    img {
      // position: absolute;
      // bottom: 0px;
    }
  }

  .weatherName {
    padding: 5px 8px;
    width: 88px;
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #d5f2ff;
    line-height: 30px;
    opacity: 1;
  }

  .s-weatherName {
    width: 32px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #d5f2ff;
    line-height: 20px;
  }

  .head-left {
    width: 770px;
    height: 70px;
    line-height: 70px;
    display: flex;
    align-items: center;
    z-index: 20;

    img {
      height: 33px;
      width: 32px;
      padding-left: 26px;
      padding-right: 20px;
    }
  }

  .head-middle {
    height: 70px;
    line-height: 70px;
    display: flex;
    align-items: center;
    z-index: 20;
  }

  .head-right {
    // width: 29.25rem;
    height: 70px;
    line-height: 70px;
    display: flex;
    align-items: center;
    z-index: 20;
    padding-right: 20px;

    img {
      height: 44px;
      width: 44px;
    }

    // img:nth-of-type(2) {
    //   padding-left: 20px;
    // }

    img:nth-of-type(4) {
      margin-left: 20px;
    }

    .line {
      width: 1px;
      height: 22px;
      background-color: #44d7b6;
      margin: 20px;
    }
  }

  .titleName {
    font-size: 20px;
    font-family: douyu;
    color: var(--titleName-color);
    font-weight: 400;
  }

  .dateTime {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-width: 80px;
    text-align: center;

    .datetext {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding-left: 20px;
    }

    .text {
      font-size: 10px;
      font-family: SourceHanSansCN-ExtraLight, SourceHanSansCN;
      font-weight: 200;
      color: #44d7b6;
      line-height: 12px;
    }

    .timetext {
      padding-left: 20px;
      width: 100px;
      font-size: 26px;
      font-family: SourceHanSansCN-Normal, SourceHanSansCN;
      font-weight: 400;
      color: #44d7b6;
      line-height: 39px;
    }
  }

  .user-info {
    span {
      width: 36px;
      height: 12px;
      font-size: 12px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #44d7b6;
      // line-height: 18px;
      line-height: 70px;

    }
  }

  .menu {
    display: flex;
    flex-direction: row;
    width: 375px;
    height: 100%;
    margin-left: 20px;

    span {
      text-align: center;
      height: 70px;
      font-size: 16px;
      font-family: SourceHanSansCN-Bold, SourceHanSansCN;
      color: var(--titleName-color);
      line-height: 70px;
      cursor: pointer;
      width: 86px;
    }

  }
}
</style>


// WEBPACK FOOTER //
// src/components/container_header.vue